module.exports = __webpack_public_path__ + "img/ticket.774c8879.svg";